const SET_LANG = (state, language) => {
  state.language = language;
};
const SET_ENVIRONMENT = (state, info) => {
  state.env = info;
};

const SET_ACCESS_TOKEN = (state, info) => {
  state.ACCESS_TOKEN_KEY = info;
};

const SET_HOMEPAGE_INFO = (state, info) => {
    state.homepageInfo = info;
}

export default {
  SET_LANG,
  SET_ACCESS_TOKEN,
  SET_ENVIRONMENT,
  SET_HOMEPAGE_INFO,
};



// WEBPACK FOOTER //
// ./src/store/modules/common/mutations.js